import { render, staticRenderFns } from "./file-preview.vue?vue&type=template&id=52e82329&scoped=true"
import script from "./file-preview.vue?vue&type=script&lang=js"
export * from "./file-preview.vue?vue&type=script&lang=js"
import style0 from "./file-preview.vue?vue&type=style&index=0&id=52e82329&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e82329",
  null
  
)

export default component.exports